/**
 * Friendly Microsoft 365 SKU (license) names. Mirror of
 * services/m365_sync.py:SKU_DISPLAY — keep these in sync. Shared by the M365
 * dashboard (Subscriptions tab) and the per-user license modal.
 */
export const SKU_DISPLAY: Record<string, string> = {
  SPB: "Microsoft 365 Business Premium",
  O365_BUSINESS_PREMIUM: "Microsoft 365 Business Standard",
  O365_BUSINESS_ESSENTIALS: "Microsoft 365 Business Basic",
  EXCHANGESTANDARD: "Exchange Online (Plan 1)",
  EXCHANGEENTERPRISE: "Exchange Online (Plan 2)",
  STANDARDPACK: "Office 365 E1",
  ENTERPRISEPACK: "Office 365 E3",
  ENTERPRISEPREMIUM: "Office 365 E5",
  SPE_E3: "Microsoft 365 E3",
  SPE_E5: "Microsoft 365 E5",
  AAD_PREMIUM: "Entra ID P1",
  AAD_PREMIUM_P2: "Entra ID P2",
  EMS: "EMS E3",
  EMSPREMIUM: "EMS E5",
  POWER_BI_STANDARD: "Power BI (free)",
  POWER_BI_PRO: "Power BI Pro",
  TEAMS_EXPLORATORY: "Teams Exploratory",
  WIN10_PRO_ENT_SUB: "Windows 10/11 Enterprise E3",
};

export const skuDisplay = (s: string): string => SKU_DISPLAY[s] || s;
